import { blogPosts } from '../../../mocks/blog-posts';

export default function FeaturedPosts() {
  const featuredPosts = blogPosts.filter(post => post.featured);

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-8 bg-[#C9A961] rounded-full"></div>
          <h2 className="text-3xl font-bold text-[#1A1F2E]" style={{ fontFamily: 'Playfair Display, serif' }}>
            Featured Articles
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {featuredPosts.map((post) => (
            <a
              key={post.id}
              href={`/travel-guides/${post.slug}`}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-64 w-full overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <span className="inline-block px-3 py-1 bg-[#C9A961] text-white text-xs font-medium rounded-full mb-3">
                    {post.category}
                  </span>
                  <h3 className="text-2xl font-bold text-white mb-2 line-clamp-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                    {post.title}
                  </h3>
                </div>
              </div>
              
              <div className="p-6">
                <p className="text-gray-600 mb-4 leading-relaxed line-clamp-3">
                  {post.excerpt}
                </p>
                
                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full overflow-hidden">
                      <img
                        src={post.authorImage}
                        alt={post.author}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-[#1A1F2E]">{post.author}</p>
                      <p className="text-xs text-gray-500">{post.date}</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <i className="ri-time-line"></i>
                    <span>{post.readTime}</span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
